import React from 'react';
import { useTranslation } from 'react-i18next';

import CheckoutTitlePage from 'components/Checkout/CheckoutTitlePage/CheckoutTitlePage';
import SignUpMetadata from 'components/Identification/Signup/SignUpMetadata';
import SignUp from 'components/Identification/Signup/SignUp';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { pushGtmEvent } from 'services/gtm/gtmEvents';
import { getRoutesUri } from 'services/generic';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function CreatePage(): JSX.Element {
  const { t } = useTranslation(['checkout']);

  useGtmPageView(GTM_PAGE_OTHER, '');

  return (
    <>
      <SignUpMetadata />
      <CheckoutTitlePage
        title={t('MY_ACCOUNT_CHECKOUT_STEP')}
        goTo={getRoutesUri<string>('cart')}
        classes={{ container: styles.sectionTitle }}
        onClick={() =>
          pushGtmEvent({
            event: '_click_other',
            category: 'clic autre - checkout',
            element: 'retour au panier',
          })
        }
      />
      <SignUp
        pageType={'checkout'}
        classes={{ container: styles.pageContainer }}
      />
    </>
  );
}
